"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCREEN_HEIGHT = exports.SCREEN_WIDTH = void 0;
exports.normalize = normalize;
exports.scaleFont = scaleFont;
const react_native_1 = require("react-native");
const react_native_device_info_1 = __importDefault(require("react-native-device-info"));
const deviceModel = react_native_device_info_1.default.getModel();
_a = react_native_1.Dimensions.get("window"), exports.SCREEN_WIDTH = _a.width, exports.SCREEN_HEIGHT = _a.height;
// based on iphone 5s's scale
// const scale = SCREEN_WIDTH / SCREEN_HEIGHT; //320;
const IS_USER_SCALE_ENABLED = false;
/**
 *
 * @param size
 * @returns
 */
function normalize(size) {
    let userScale = react_native_1.PixelRatio.getFontScale();
    // if (userScale > 1.15) userScale = 1; //.15;
    if (!IS_USER_SCALE_ENABLED)
        return size;
    const newSize = userScale * size;
    if (react_native_1.Platform.OS === "ios") {
        return Math.round(react_native_1.PixelRatio.roundToNearestPixel(newSize));
    }
    else {
        return Math.round(react_native_1.PixelRatio.roundToNearestPixel(newSize)) - 2;
    }
}
/**
 * @param size
 * @returns
 */
function scaleFont(baseSize) {
    let userScale = react_native_1.PixelRatio.getFontScale();
    const pixel = react_native_1.PixelRatio.get();
    let fontAddition = 0;
    let fontSet = {
        24: 0, // screen heading
        20: 0, // section heading
        14: 0, //section sub heading
        10: 0 //
    };
    if (deviceModel.includes('iPhone SE')) {
        fontAddition = 0; // do nothing if base font
        // This is an iPhone SE or a model with similar naming convention
        // Handle accordingly
    }
    else if (deviceModel.includes('iPhone 13')) {
        fontSet = {
            24: 4, // screen heading = 24+4 = 28
            20: 2, // section heading
            14: 2, //section sub heading
            10: 1 //
        };
        fontAddition = fontSet?.[baseSize] || 0; // do nothing if base font
        // This is an iPhone 13 or a model with similar naming convention
        // Handle accordingly
    }
    else if (deviceModel.includes('iPhone 15') || deviceModel.includes('iPhone 14')) {
        fontSet = {
            24: 4, // screen heading
            20: 2, // section heading
            14: 2, //section sub heading
            10: 1 //
        };
        fontAddition = fontSet?.[baseSize] || 0; // do nothing if base font
        // This is an iPhone 13 or a model with similar naming convention
        // Handle accordingly
    }
    else {
        fontSet = {
            24: 4, // screen heading
            20: 2, // section heading
            14: 2, //section sub heading
            10: 1 //
        };
        fontAddition = fontSet?.[baseSize] || 0; // do nothing if base font
    }
    return baseSize + fontAddition;
    // if (userScale > 1.15) userScale = 1; //.15;
    if (!IS_USER_SCALE_ENABLED)
        return baseSize;
    const newSize = userScale * baseSize;
    if (react_native_1.Platform.OS === "ios") {
        return Math.round(react_native_1.PixelRatio.roundToNearestPixel(newSize));
    }
    else {
        return Math.round(react_native_1.PixelRatio.roundToNearestPixel(newSize)) - 2;
    }
}
